<template>
    <div class="content">
        <div class="timeLeft" v-if="haveTime==1&&mode!=2">
            <div class="timeLeftText1">
                您当前的学习模式：集训营模式 ( 剩余有效学时：<span style="font-family:PingFang SC;font-weight: 600;">{{djsDay}}</span>&nbsp; 天 &nbsp;<span style="font-family:PingFang SC;font-weight: 600;">{{djsHour}}</span>&nbsp; 小时 &nbsp;<span style="font-family:PingFang SC;font-weight: 600;">{{djsMin}}</span>&nbsp; 分钟 &nbsp;<span style="font-family:PingFang SC;font-weight: 600;">{{djsSecond}}</span>&nbsp; 秒  ) 
            </div>
            <div class="changeMode" @click="shadow=1;dajishiOn()">
                <div class="changeModeText1">切换至自主学习模式</div>
                <img src="~@/assets/globalCourse/白色箭头.png" alt="" class="changeModeIcon">
            </div>
        </div>
        <div class="timeLeft" v-if="haveTime==2&&mode!=2">
            <div class="timeLeftText1">
                您的有效学时已用尽，无法申请证书，但您可以继续学习
            </div>
            <div class="changeMode" @click="shadow=1;dajishiOn()">
                <div class="changeModeText1">切换至自主学习模式</div>
                <img src="~@/assets/globalCourse/白色箭头.png" alt="" class="changeModeIcon">
            </div>
        </div>
        <div class="timeLeft" v-if="haveTime==3&&mode!=2" @click="$router.push('/graduationCertificate')">
            您已结业！<span style="cursor: pointer;">申请结业证书</span>
            <img src="~@/assets/globalCourse/白色箭头.png" alt="" class="timeLeftIcon">
        </div>
        <div class="timeLeft" v-if="haveTime==4&&mode!=2">您已完成全部学习内容</div>
        <div class="timeLeft" v-if="mode==2">您当前为自主学习模式，可自由选择课程任意部分学习</div>

        <div class="content1280">
            <div class="top">
            <div class="titleText1" @click="$router.push('/')">首页 /</div>
            <div class="titleText1" style="left: 53px;color: #3A3A3A;width: 64px;">线上课堂</div>
            </div>
            <!-- 继续学习 -->
            <div class="studyContinue" v-if="status==1">
                <div class="conText1">尊敬的用户，您上次学习到《{{courseName}}》课程{{lastTime}}，<span style="cursor: pointer;" @click="courseContinue()">点击继续学习</span></div>
                <img src="~@/assets/globalCourse/白色箭头.png" alt="" class="conImg" @click="courseContinue()">
                <img src="~@/assets/globalCourse/关闭.png" alt="" class="deleteTip" @click="status=0"> 
            </div>
            <div class="whiteArea">
                <div class="whiteText1">内容方向</div>
                <div class="whiteText1" style="top: 111px;">课程级别</div>  
            <!-- 内容方向-->
                <!-- 全部 -->
                <img src="~@/assets/globalCourse/选中.png" alt="" class="courseAll-s" v-if="contentAll==1" @click="contentAllUnSelect()">
                <img src="~@/assets/globalCourse/未选中.png" alt="" class="courseAll" v-if="contentAll==0" @click="contentAllSelect()">
                <div class="selectText1">全部</div>
                <!-- 卫星遥感基础 -->
                <img src="~@/assets/globalCourse/选中.png" alt="" class="courseAll-s" style="left: 254px;" v-if="content1==1" @click="content1UnSelect()">
                <img src="~@/assets/globalCourse/未选中.png" alt="" class="courseAll" style="left: 254px;" v-if="content1==0" @click="content1Select()">
                <div class="selectText1" style="left: 282px;">卫星遥感基础</div>

                <!-- 卫星遥感数据处理 -->
                <img src="~@/assets/globalCourse/选中.png" alt="" class="courseAll-s" style="left: 480px;" v-if="content2==1" @click="content2UnSelect()">
                <img src="~@/assets/globalCourse/未选中.png" alt="" class="courseAll" style="left: 480px;" v-if="content2==0" @click="content2Select()">
                <div class="selectText1" style="left: 508px;">卫星遥感数据处理基础</div>


                <!-- 卫星遥感数据高级处理 -->
                <img src="~@/assets/globalCourse/选中.png" alt="" class="courseAll-s" style="left: 706px;" v-if="content3==1" @click="content3UnSelect()">
                <img src="~@/assets/globalCourse/未选中.png" alt="" class="courseAll" style="left:706px;" v-if="content3==0" @click="content3Select()">
                <div class="selectText1" style="left:734px;">卫星遥感数据高级处理</div>


                <!-- 卫星遥感行业应用 -->
                <img src="~@/assets/globalCourse/选中.png" alt="" class="courseAll-s" style="left: 932px;" v-if="content4==1" @click="content4UnSelect()">
                <img src="~@/assets/globalCourse/未选中.png" alt="" class="courseAll" style="left: 932px;" v-if="content4==0" @click="content4Select()">
                <div class="selectText1" style="left: 960px;">卫星遥感行业应用</div>


                <!-- 遥感智能解译技术及应用 -->
                <img src="~@/assets/globalCourse/选中.png" alt="" class="courseAll-s" style="left: 254px;top: 65px;" v-if="content5==1" @click="content5UnSelect()">
                <img src="~@/assets/globalCourse/未选中.png" alt="" class="courseAll" style="left: 254px;top: 65px;" v-if="content5==0" @click="content5Select()">
                <div class="selectText1" style="left: 282px;top: 65px;">遥感智能解译技术及应用</div>


                <!-- 植被定量遥感技术及应用 -->
                <img src="~@/assets/globalCourse/选中.png" alt="" class="courseAll-s" style="top: 67px;left: 480px;" v-if="content6==1" @click="content6UnSelect()">
                <img src="~@/assets/globalCourse/未选中.png" alt="" class="courseAll" style="top: 67px;left: 480px;" v-if="content6==0" @click="content6Select()">
                <div class="selectText1" style="left: 508px;top: 65px;">植被定量遥感技术及应用</div>

                <!-- GIS系统开发技术及应用 -->
                <img src="~@/assets/globalCourse/选中.png" alt="" class="courseAll-s" style="top: 67px;left: 706px;" v-if="content7==1" @click="content7UnSelect()">
                <img src="~@/assets/globalCourse/未选中.png" alt="" class="courseAll" style="top: 67px;left: 706px;" v-if="content7==0" @click="content7Select()">
                <div class="selectText1" style="left: 734px;top: 65px;">GIS系统开发技术及应用</div>

                <!-- 天空地一体化综合监测技术及应用 -->
                <img src="~@/assets/globalCourse/选中.png" alt="" class="courseAll-s" style="top: 67px;left: 932px;" v-if="content8==1" @click="content8UnSelect()">
                <img src="~@/assets/globalCourse/未选中.png" alt="" class="courseAll" style="top: 67px;left: 932px;" v-if="content8==0" @click="content8Select()">
                <div class="selectText1" style="left: 960px;top: 65px;">天空地一体化综合监测技术及应用</div>


            <!-- 课程级别-->
                <!-- 全部 -->
                <img src="~@/assets/globalCourse/选中.png" alt="" class="courseAll-s" style="top: 113px;" v-if="levelAll==1" @click="levelAllUnSelect()">
                <img src="~@/assets/globalCourse/未选中.png" alt="" class="courseAll" style="top: 113px;" v-if="levelAll==0" @click="levelAllSelect()">
                <div class="selectText1" style="left: 172px;top: 111px;">全部</div>


                <!-- 入门级 -->
                <img src="~@/assets/globalCourse/选中.png" alt="" class="courseAll-s" style="top: 113px;left: 254px;" v-if="level1==1" @click="level1UnSelect()">
                <img src="~@/assets/globalCourse/未选中.png" alt="" class="courseAll" style="top: 113px;left: 254px;" v-if="level1==0" @click="level1Select()">
                <div class="selectText1" style="left:282px;top: 111px;">入门级</div>


                <!-- 进阶级 -->
                <img src="~@/assets/globalCourse/选中.png" alt="" class="courseAll-s" style="top: 113px;left: 480px;" v-if="level2==1" @click="level2UnSelect()">
                <img src="~@/assets/globalCourse/未选中.png" alt="" class="courseAll" style="top: 113px;left: 480px;" v-if="level2==0" @click="level2Select()">
                <div class="selectText1" style="left: 508px;top: 111px;">进阶级</div>


                <!-- 专家级 -->
                <img src="~@/assets/globalCourse/选中.png" alt="" class="courseAll-s" style="top: 113px;left: 706px;" v-if="level3==1" @click="level3UnSelect()">
                <img src="~@/assets/globalCourse/未选中.png" alt="" class="courseAll" style="top: 113px;left: 706px;" v-if="level3==0" @click="level3Select()">
                <div class="selectText1" style="left: 734px;top: 111px;">专家级</div>
<!--                     
                <div class="whiteTip">各位学员：12月12日~24日每周一、周四10:00更新上线课程视频</div> -->

            </div> 
            <div class="top" style="height: 28px;margin-top: 43px;margin-bottom: 43px;">
                <div :class="dataShow == 1 ? 'text1' : 'text1-s'" @click="dataShow=1,type='0'">循序</div>
                <div :class="dataShow == 2 ? 'text1' : 'text1-s'" style="left: 176px;" @click="dataShow=2,type='1'">人气</div>
                <div class="line1"></div>
            </div>
                
            <div class="courseList">
            <div class="courseShow" v-for="(item, index) in courseList" :key="index" @click="goCourseDetail(item)">
                <img :src="item.avatar" alt="" class="courseBackground">
                <img src="~@/assets/globalCourse/小logo.png" alt="" class="cgwxImg" v-if="item.originalStatus==1">
                <img src="~@/assets/globalCourse/全部完成.png" alt="" class="courseStatus" v-if="item.learnStatus==1&&mode!=2">
                <div class="courseDetail">
                    <div class="courseDetailText1">{{item.name}}</div>
                    <img src="~@/assets/globalCourse/吉林一号原创.png" alt="" class="courseDetailImg1" v-if="item.originalStatus==1">
                    <img src="~@/assets/globalCourse/入门级.png" alt="" class="courseDetailImg2" v-if="item.level==0">
                    <img src="~@/assets/globalCourse/进阶级.png" alt="" class="courseDetailImg2" v-if="item.level==1">
                    <img src="~@/assets/globalCourse/专家级.png" alt="" class="courseDetailImg2" v-if="item.level==2">
                    <img src="~@/assets/globalCourse/课程总时长icon.png" alt="" class="courseDetailImg3">
                    <div class="courseDetailText2">{{item.videoLength}}min</div>
                </div>
            </div>
            </div>
        </div>
        <div class="shadow" v-if="shadow == 1">
            <div class="shadowContent">
                <img src="~@/assets/globalCourse/关闭.png" alt="" class="shadowIcon" @click="shadow=0;reDaojishi()">
                <div class="shadowText1">切换自主学习模式提示</div>
                <div class="shadowText2">当您切换至自主学习模式后，可自由安排学习计划，无时限和作业要求，也可根据自己的兴趣和需求自由选择课程内容，学习过程可自定进度。<br>
                    <span style="color:#FF6666 ;">请知悉：自主学习模式下不支持切换回集训营模式，且不提供结业证书。</span>
                </div>
                <div class="shadowButton1" v-if="waiting">确定切换 ({{ second }}s)</div>
                <div class="shadowButton1-s" v-if="!waiting" @click="exchangeMode()">确定切换</div>
                <div class="shadowButton2" @click="shadow=0;reDaojishi()">我再想想</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
      name: "globalCourse",
      data() {
        return {
          haveTime:0,
          contentAll:1,
          content1:0,  
          content2:0,  
          content3:0,  
          content4:0,  
          content5:0,  
          content6:0,  
          content7:0,  
          content8:0,  
          levelAll:1,
          level1:0,
          level2:0,
          level3:0,
          dataShow:1,
          courseList:[],
          categoryList:[],
          levelList:[],
          courseName:"",
          lastTime:"",
          status:0,
          videoId:'',
          videoList:[],
          index:-1,
          //倒计时
          djsDay:89,
          djsHour:23,
          djsMin:59,
          djsSecond:2,
          timer1:'',
          firstStatus:0,
          //人气
          type:'0',
          //模式
          mode:0,
          shadow:0,
          second: 5,
          waiting: true,
          timer: "",

        };
      },
      methods: {
        getKey() {
          return localStorage.getItem("token");
        },
        getCourseData(){
            let categoryList = ""
            let levelList = ""
            if(this.categoryList.length == 0){
                categoryList = ""
            }else{
                for(let i = 0;i< this.categoryList.length;i++){
                    categoryList = categoryList+this.categoryList[i]
                    if(i<this.categoryList.length-1){
                        categoryList = categoryList + ','
                    }
                }
            }
            if(this.levelList.length == 0){
                levelList = ""
            }else{
                for(let i = 0;i< this.levelList.length;i++){
                    levelList = levelList+this.levelList[i]
                    if(i<this.levelList.length-1){
                        levelList = levelList + ','
                    }
                }
            }
            var userInfo = {
                   "categoryList":this.categoryList,
                   "levelList":this.levelList,
                   "type":this.type
                }
            console.log(userInfo,this.categoryList,"qingqiuqian ");
            console.log("获取课程列表Bearer",this.getKey());
            // let token = this.getKey() ===null ? "" : this.getKey()
            this.axios.get(
            "/learn_back/course/courseDetail/list",{
                params:{
                    "categoryList": categoryList,
                    "levelList": levelList,
                    "type":this.type
                }
            },
            {
              headers: {
                Authorization: "Bearer "+ this.getKey() ,
              },
            }
          )
          .then((res) => {
            let resData = res.data;
            console.log(resData.msg);
            if (resData.msg != "操作成功") {
              alert("暂无课程");
              console.log("课程列表",res.data);
            } else{
                console.log("课程列表",res.data);
                this.courseList=resData.data
                console.log(this.courseList)
            }
          });
        },
        goCourseDetail(item){
            // console.log(item.id)
            localStorage.setItem("courseId", item.id);
            this.$router.push({path:'/courseShow',query:{'courseId':item.id}});
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: "instant",
            });
        },
        contentDelete(){
            let list = []
            if(this.contentAll==0){
                if(this.content1==1){
                list.push(0)
            }
            if(this.content2==1){
                list.push(1)
            }
            if(this.content3==1){
                list.push(2)
            }
            if(this.content4==1){
                list.push(3)
            }
            if(this.content5==1){
                list.push(4)
            }
            if(this.content6==1){
                list.push(5)
            }
            if(this.content7==1){
                list.push(6)
            }
            if(this.content8==1){
                list.push(7)
            }
            }else if(this.contentAll==1){
                list=[]
            }
            if(list.length==0){
                this.contentAll=1
            }
            this.categoryList=list

        },
        levelDelete(){
            let list =[]
            if(this.levelAll==0){
                if(this.level1==1){
                    list.push(0)
                }
                if(this.level2==1){
                    list.push(1)
                }
                if(this.level3==1){
                    list.push(2)
                }
            }else if(this.levelAll==1){
                list=[]
            }
            if(list.length==0){
                this.levelAll=1
            }
            this.levelList=list
        },
        contentAllSelect(){
            this.contentAll=1;
            this.content1=0;
            this.content2=0;
            this.content3=0;
            this.content4=0;
            this.content5=0;
            this.content6=0;
            this.content7=0;
            this.content8=0;
            this.categoryList=[];
            // console.log(this.categoryList)
        },
        contentAllUnSelect(){
            this.contentDelete()
        },
        content1Select(){
            this.content1=1;
            this.contentAll=0;
            this.categoryList.push(0)
            // console.log(this.categoryList)
        },
        content2Select(){
            this.content2=1;
            this.contentAll=0;
            this.categoryList.push(1)
            // console.log(this.categoryList)

        },
        content2UnSelect(){
            this.content2=0; 
            this.contentDelete()
        },
        content3Select(){
            this.content3=1;
            this.contentAll=0;
            this.categoryList.push(2)
            // console.log(this.categoryList)

        },
        content3UnSelect(){
            this.content3=0; 
            this.contentDelete()
        },
        content4Select(){
            this.content4=1;
            this.contentAll=0;
            this.categoryList.push(3)
            // console.log(this.categoryList)

        },
        content4UnSelect(){
            this.content4=0; 
            this.contentDelete()
        },
        content5Select(){
            this.content5=1;
            this.contentAll=0;
            this.categoryList.push(4)
            // console.log(this.categoryList)

        },
        content5UnSelect(){
            this.content5=0; 
            this.contentDelete()
        },
        content6Select(){
            this.content6=1;
            this.contentAll=0;
            this.categoryList.push(5)
            // console.log(this.categoryList)
        },
        content6UnSelect(){
            this.content6=0; 
            this.contentDelete()
        },
        content7Select(){
            this.content7=1;
            this.contentAll=0;
            this.categoryList.push(6)
            // console.log(this.categoryList)
        },
        content7UnSelect(){
            this.content7=0; 
            this.contentDelete()
        },
        content8Select(){
            this.content8=1;
            this.contentAll=0;
            this.categoryList.push(7)
            // console.log(this.categoryList)
        },
        content8UnSelect(){
            this.content8=0; 
            this.contentDelete()
        },
        
        levelAllSelect(){
            this.levelAll=1;
            this.level1=0;
            this.level2=0;
            this.level3=0;
            this.levelList=[];
        },
        levelAllUnSelect(){
            this.levelDelete()
        },
        level1Select(){
            this.level1=1;
            this.levelAll=0;
            this.levelList.push(0)
        },
        level2Select(){
            this.level2=1;
            this.levelAll=0;
            this.levelList.push(1)
        },
        level3Select(){
            this.level3=1;
            this.levelAll=0;
            this.levelList.push(2)
        },
        content1UnSelect(){
            this.content1=0; 
            this.contentDelete()
        },
        level1UnSelect(){
            this.level1=0;
            this.levelDelete()
        },
        level2UnSelect(){
            this.level2=0;
            this.levelDelete()
        },
        level3UnSelect(){
            this.level3=0;
            this.levelDelete()
        },
        getCourseCon(){
            this.axios.get(
            "/learn_back/course/courseLearn/getLastLearnInfo",
            {
              headers: {
                Authorization: "Bearer "+ this.getKey() ,
              },
            }
          )
          .then((res) => {
            let resData = res.data;
            if (resData.msg == "操作成功") {
                console.log(resData.data)
                if(resData.data.status==1){
                    this.status=0
                }else{
                    this.status=1
                    this.videoId=resData.data.videoId
                    this.videoList=resData.data.videoList
                    this.courseName=resData.data.title
                    this.index=resData.data.videoIndex
                    // console.log(resData.data)
                    let t = Math.floor(resData.data.learnRate)
                    let hour = Math.floor(t/3600)
                    if(hour<1){
                        hour=0
                    }
                    let min = Math.floor((t-3600*hour)/60)
                    if(min<1){
                         min=0
                    }
                    let second=Math.floor(t-3600*hour-60*min)
                    if(hour==0){
                        if(min==0){
                            this.lastTime=second+"秒"
                        }else{
                            this.lastTime=min+"分"+second+"秒"
                        }
                    }else{
                        this.lastTime=hour+"时"+min+"分"+second+"秒"
                    }
                }
            }
          });
        },
        courseContinue(){
            this.$router.push({path:'/coursePlay',query:{'videoId':this.videoId,'videoList':this.videoList,'index':this.index-1}});
        },
        effectiveTime(){
           if(this.djsDay==0&&this.djsHour==0&&this.djsMin==0&&this.djsSecond==0){
            this.haveTime=2
            clearInterval(this.timer1);
           }else{
            if(this.djsSecond<=0){
                this.djsSecond=59
                if(this.djsMin<=0){
                    this.djsMin=59
                    if(this.djsHour<=0){
                        this.djsHour=23
                        if(this.djsDay<0){
                            this.haveTime=2
                            clearInterval(this.timer1);
                        }else{
                            this.djsDay--
                        }
                    }else{
                        this.djsHour--
                    }
                }else{
                    this.djsMin--
                }
            }else{
                this.djsSecond--
            }
           }
        },
        effectiveTimeOn(){
            this.$nextTick(() => {
            this.timer1 = setInterval(this.effectiveTime, 1000);
        });
        },
        firstStudy(){
            this.axios.post(
            "/learn_back/course/courseLearn/sendUserFirstLearnStatus/0",null,
            {
              headers: {
                Authorization: "Bearer "+ this.getKey() ,
              },
            }
          )
          .then((res) => {
            let resData = res.data;
            if (resData.msg != "操作成功") {
              console.log("获取用户信息失败")
            } else {
                 //mode 0 集训营 1 线下 2 自主学习
                this.mode=resData.data.mode
                this.$store.state.mode=this.mode 
                this.firstStatus=resData.data.firstLearnStatus
                this.djsDay=resData.data.remainLearnTime[0]
                this.djsHour=resData.data.remainLearnTime[1]
                this.djsMin=resData.data.remainLearnTime[2]
                this.djsSecond=resData.data.remainLearnTime[3]
                let totalLearnStatus = resData.data.totalLearnStatus
                // console.log('totalLearnStatus==0', 0=="");
                if(totalLearnStatus==0){
                    console.log('totalLearnStatus==0');
                    console.log(totalLearnStatus);
                    if(this.firstStatus==0){
                        this.haveTime=0
                    }else if(this.firstStatus==1){
                        if(this.djsDay<=0&&this.djsHour<=0&&this.djsMin<=0&&this.djsSecond<=0){
                            this.haveTime=2
                        }else{
                            this.haveTime=1
                            this.effectiveTimeOn()
                        }
                    }
                }else if(totalLearnStatus==1){
                    console.log('totalLearnStatus==1');
                    this.haveTime=3
                }else{
                    this.haveTime=4
                }  
            }
          });
        },
        daojishi() {
            if (this.second <= 0) {
                this.waiting = false;
                clearInterval(this.timer);
            } else {
                this.second--;
            }
        },
        dajishiOn() {
            this.$nextTick(() => {
                this.timer = setInterval(this.daojishi, 1000);
            });
        },
        reDaojishi(){
            this.waiting=true
            this.second=5
            clearInterval(this.timer)
        },
        exchangeMode(){
            var userInfo = {
                education: '硕士',
                age: '27',
                sex: '1',
                major: "计算机科学与技术",
                company: "长光卫星",
                email: "121@qq.com"
            }
            this.axios.post(
                "/learn_back/course/register/saveFreeLearnCourseRegister", userInfo,
                {
                headers: {
                    Authorization: "Bearer " + this.getKey(),
                },
                }
            ).then((res) => {
                console.log(res);
                this.mode=2
                this.shadow=0
                });
        }
      },
      mounted() {
        this.getCourseData()
        this.getCourseCon()
        this.firstStudy()
      },
      watch:{
        categoryList:{
            handler(val) {
        this.getCourseData()
        }
        },
        levelList:{
            handler(val){
                this.getCourseData()
            }
        },
        type:{
            handler(val){
                this.getCourseData()
            }
        }
      },
      computed: {
        
      },
    };
    </script>
<style scoped>
.content{
    position: relative;
    margin-top: 76px;
    width: 100%;
    height: auto;
    background: #F5F5F6;
    padding-top: 1px;
    overflow: hidden;
}
.content1280{
    position: relative;
    /* position: absolute; */
    /* margin-top: 160px; */
    width: 1280px;
    height:auto;
    margin-left: calc(50% - 640px);
} 
.timeLeft{
    position: relative;
    width:100%;
    height: 40px;
background: #C49760;
font-size: 14px;
font-family: PingFangSC-Light;
font-weight: 300;
color: rgba(255, 255, 255, 0.8);
line-height: 40px;
text-align: center;
}
.timeLeftIcon{
    position: absolute;
    top: 15px;
    left: calc(50% + 85px);
    width: 6px;
    height: 10px;
    cursor: pointer;
}
.timeLeftText1{
position: absolute;
width: 1280px;
height: 40px;
left: calc(50% - 640px);
text-align: left;
}
.timeLeftText2{
 position: absolute;
width: 330px;
height: 40px;
left: 0;
/* background-color: pink; */
font-size: 14px;
font-family: PingFangSC-Light;
font-weight: 300;
color: rgba(255, 255, 255, 0.8);
line-height: 40px;
text-align: left;
}
.timeLeftText3{
    position: absolute;
    left: 125px;
    width: 20px;
    height: 40px;
    /* background-color: pink; */
    font-family:PingFang SC;
    font-weight: 600;
    line-height: 40px;
    color: #ffffff;
    text-align: right;
}
.titleText1{
    position: absolute;
    top: 0px;
    left: 0;
    width: 46px;
height: 22px;
font-size: 16px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #979797;
line-height: 22px;
cursor: pointer;
}
.whiteArea{
  position: relative;
    margin-top: 40px;
    margin-left: 0;
    width: 1280px;
height: 160px;
background: #FFFFFF;
border-radius: 16px;
}
.whiteText1{
    position: absolute;
    top: 25px;
    left: 40px;
    width: 64px;
height: 22px;
font-size: 16px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 22px;
}
.courseAll{
    position: absolute;
    top: 27px;
    left: 144px;
    width: 18px;
height: 18px;
cursor: pointer;
}
.courseAll-s{
    position: absolute;
    top: 27px;
    left: 144px;
    width: 18px;
height: 18px;
cursor: pointer;

}
.whiteTip{
    position: absolute;
    top: 171px;
    left: calc(50% - 600px);
    width: 1200px;
height: 47px;
background: rgba(196,151,96,0.1);
border-radius: 8px;
font-size: 16px;
font-family: PingFangSC-Light, PingFang SC;
font-weight: 300;
color: rgba(196, 151, 96, 0.8);
line-height:47px;
text-align: center;
}
.selectText1{
    position: absolute;
    top: 25px;
    left: 172px;
    width: 300px;
height: 22px;
font-size: 16px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #979797;
line-height: 22px;
text-align: left;
}
.text1{
    position: absolute;
    top: 0px;
    left: 40px;
    width: 50px;
height: 22px;
font-size: 16px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #C49760;
line-height: 22px;
}
.text1-s{
    position: absolute;
    top: 0px;
    left: 40px;
    width: 50px;
height: 22px;
font-size: 16px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #3A3A3A;
line-height: 22px;
cursor: pointer;
}
.line1{
    position: absolute;
    top:0px;
    left: 122px;
    width: 1px;
height: 28px;
background-color: #3A3A3A;
}
.courseList{
    margin-top: 0px;
    width: 1320px;
    height:auto;
    padding-bottom: 40px;
    /* background-color: pink; */
    overflow: hidden;
}
.top{
   position: relative;
   margin-top:60px;
    width: 100%;
    height: 22px;
    /* background-color: pink; */
}
.studyContinue{
    margin-top: 40px;
    width: 1280px;
height: 72px;
background: #C49760;
border-radius: 16px;
overflow: hidden;
}
.conText1{
    float: left;
margin-top:25px;
margin-left: 350px;
    width: auto;
height: 22px;
font-size: 16px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #FFFFFF;
line-height: 22px;  
text-align: left;
}
.conImg{
    float: left;
    margin-top:30px;
    margin-left: 8px;
    width: 7px;
height: 12px;
cursor: pointer;
}
.deleteTip{
    float: right;
    margin-top: 25px;
    margin-right: 20px;
    width: 18px;
    height: 18px;
    cursor: pointer;
}
.courseShow{
    position: relative;
    float: left;
    width: 400px;
height: 298px;
/* background: plum; */
box-shadow: 0px 0px 10px 2px rgba(119,119,119,0.25);
border-radius: 16px;
margin-right: 40px;
margin-bottom: 40px;
cursor: pointer;
}
.courseBackground{
    position: absolute;
    width: 400px;
    height: 225px;
    border-radius: 16px;
}
.cgwxImg{
    position: absolute;
    top: 7px;
    left: 13px;
    width: 44px;
    height: 44px;

}
.courseStatus{
    position: absolute;
    top: 191px;
    left: 279px;
    width:121px;
    height:107px;
    z-index: 1;
}
.courseDetail{
    position: absolute;
    width: 400px;
    height: 108px;
    top: 190px;
background: #FFFFFF;

border-radius: 0px 0px 16px 16px;
}
.courseDetailText1{
    position: absolute;
    top: 15px;
    left: 21px;
    width: 376px;
height: 22px;
font-size: 16px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 22px;
}
.courseDetailImg1{
    position: absolute;
    top: 59px;
    left: 21px;
    width: 96px;
height: 26px;
}
.courseDetailImg2{
    position: absolute;
    top: 59px;
    left: 127px;
    width: 60px;
height: 26px;
}
.courseDetailImg3{
    position: absolute;
    top: 67px;
    left: 312px;
    width: 16px;
height: 16px;
}
.courseDetailText2{
    position: absolute;
    top: 65px;
    right: 21px;
    width: 51px;
height: 20px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #979797;
line-height: 20px;
text-align: right;
}
.changeMode{
    position: absolute;
    left: calc(50% + 460px);
    top: 5px;
    width: 180px;
    height: 30px;
    background: #C49760;
    border-radius: 15px;
    border: 1px solid #FFFFFF;
    cursor: pointer;
}
.changeModeText1{
    position: absolute;
    top: 8px;
    left: 21px;
    width: auto;
    height: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 14px;
}
.changeModeIcon{
    position: absolute;
    top: 9px;
    left: 153px;
    width: 6px;
    height: 12px;
}
.shadow{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10000;
    backdrop-filter: blur(2px);
}
.shadowContent{
    position: absolute;
    top: calc(50% - 200px);
    left: calc(50% - 400px);
    width: 800px;
    height: 400px;
    background: #FFFFFF;
    border-radius: 16px;
}
.shadowIcon{
    position: absolute;
    top: 0;
    right: -50px;
    width: 40px;
    height: 40px;
}
.shadowText1{
    position: absolute;
    top: 50px;
    width: 800px;
    height: 28px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #3A3A3A;
    line-height: 28px;
    text-align: center;
}
.shadowText2{
    position: absolute;
    top: 118px;
    left: 100px;
    width: 600px;
    height: 90px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #3A3A3A;
    line-height: 30px;
    text-align: justify;
    font-style: normal;
}
.shadowButton1{
    position: absolute;
    top: 306px;
    left: 243px;
    width: 150px;
    height: 44px;
    background: #CCCCCC;
    border-radius: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 22px;
    line-height: 44px;
    text-align: center;
}
.shadowButton1-s{
    position: absolute;
    top: 306px;
    left: 243px;
    width: 150px;
    height: 44px;
    background: #C49760;
    border-radius: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 22px;
    line-height: 44px;
    text-align: center;
    cursor: pointer;
}
.shadowButton2{
    position: absolute;
    top: 306px;
    left: 408px;
    width: 150px;
    height: 44px;
    background: #FFFFFF;
    border-radius: 22px;
    border: 1px solid #C49760;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #C49760;
    line-height: 44px;
    cursor: pointer;
    text-align: center;
}
</style>